var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Stock Code",
                  value: _vm.id,
                  readonly: "",
                  dense: "",
                  outlined: "",
                  "error-messages": _vm.errorMessages.id || []
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", lg: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  label: "Stock Category",
                  value: _vm.stockCategoryId,
                  disabled: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", lg: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Product Name",
                  "error-messages": _vm.errorMessages.product_name || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.productName,
                  callback: function($$v) {
                    _vm.productName = $$v
                  },
                  expression: "productName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", lg: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Brand Name",
                  "error-messages": _vm.errorMessages.brand_name || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.brandName,
                  callback: function($$v) {
                    _vm.brandName = $$v
                  },
                  expression: "brandName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", lg: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Product Type",
                  "error-messages": _vm.errorMessages.product_type || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.productType,
                  callback: function($$v) {
                    _vm.productType = $$v
                  },
                  expression: "productType"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Description",
                  "error-messages": _vm.errorMessages.description || [],
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }